import React from "react";
import "../styles/PremiumBadge.css";

function PremiumBadge({ size = "sm", className = "" }) {
  return (
    <span
      className={`premium-badge premium-badge-${size}${className ? ` ${className}` : ""}`}
      aria-label="Premium"
      title="Premium"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M5 16l-1.5-8 4.5 3.2L12 5l4 6.2L20.5 8 19 16H5zm0 2h14v2H5v-2z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}

export default PremiumBadge;
